// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__38u-b","savePackageButton":"ClientWallet_savePackageButton__3XqH_"};